import { Injectable, NgZone } from '@angular/core';
import { GraphqlService } from './graphql.service';
import { Observable } from 'rxjs';
import { LanguageSchema } from '../schemas/language.schema';
import { LoaderService } from './loader.service';
import { NotifyOrConfirmService } from './notify-or-confirm.service';
import { HttpClient } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { SessionService } from './session.service';
import { ConfigService } from './config.service';
import { TranslateService } from '@ngx-translate/core';
import { DateFormatService } from './dateFormat.service';
import { Router } from '@angular/router';
import { LoggerService } from './logger.service';
import { ToastrService } from 'ngx-toastr';
import { WindowRefService } from './window.service';

@Injectable({
	providedIn: 'root'
})
export class LocaleGraphqlService extends GraphqlService {
	constructor(
		// Services for parent
		protected loaderService: LoaderService,
		protected notifyOrConfirmService: NotifyOrConfirmService,
		protected http: HttpClient,
		protected httpLink: HttpLink,
		protected sessionService: SessionService,
		protected configService: ConfigService,
		protected translateService: TranslateService,
		protected dateFormatService: DateFormatService,
		protected router: Router,
		protected logger: LoggerService,
		protected ngZone: NgZone,
		protected toastrService: ToastrService,
		protected windowService: WindowRefService
	) {
		super(
			http,
			httpLink,
			configService,
			loaderService,
			notifyOrConfirmService,
			sessionService,
			translateService,
			router,
			logger,
			ngZone,
			toastrService,
			windowService
		);
	}

	/**
	 * Set Language for server communication
	 */
	setCommunicationLanguage(languageCode: string): Observable<boolean> {
		return new Observable<boolean>((subscriber) => {
			// Change dev to english
			if (languageCode === 'resources') {
				languageCode = 'en-GB';
			}

			if (languageCode && this.sessionService.session) {
				this.mutation(LanguageSchema.setSessionCulture, { culture: languageCode }, { showSuccessMessage: false }).subscribe(
					() => {
						subscriber.next(true);
						subscriber.complete();
					},
					(error) => {
						this.logger.error(error);
						subscriber.error(error);
					}
				);
			} else {
				subscriber.next(false);
				subscriber.complete();
			}
		});
	}

	getConnectionDetails(): Observable<{ countryCode: string; enableCaptcha: boolean }> {
		return new Observable<{ countryCode: string; enableCaptcha: boolean }>((subscriber) => {
			this.query(LanguageSchema.getConnectionDetails).subscribe(
				(data: { getConnectionDetails: { countryCode: string; enableCaptcha: boolean } }) => {
					subscriber.next({ countryCode: data.getConnectionDetails.countryCode, enableCaptcha: data.getConnectionDetails.enableCaptcha });
					subscriber.complete();
				},
				(error) => {
					this.logger.error(error);
					subscriber.error(error);
				}
			);
		});
	}
}
